<template>
  <div>
    <div class="pending-goods-descriptions">
      <div class="pending-goods-descriptions-image">
        <el-image
          :src="displayImage"
          :preview-src-list="[displayImage]"
          fit="cover"
        />
      </div>

      <div class="pending-goods-descriptions-info">
        <div class="descriptions">
          <el-row class="descriptions-row">
            <el-col :span="12" class="descriptions-item">
              <div class="descriptions-label">
                {{ $l('form_label_masterNcNo') || '成品编码' }}
              </div>
              <div class="descriptions-content">
                {{ info.masterNcNo || '--' }}
              </div>
            </el-col>
            <el-col :span="12" class="descriptions-item">
              <div class="descriptions-label">
                {{ $l('form_label_ncNo') || '子件编码' }}
              </div>
              <div class="descriptions-content">
                {{ info.ncNo || '--' }}
              </div>
            </el-col>
          </el-row>

          <el-row class="descriptions-row">
            <el-col :span="24" class="descriptions-item">
              <div class="descriptions-label">
                {{ $l('form_label_goodsName') || '产品名称' }}
              </div>
              <div class="descriptions-content">
                {{ info.goodsName || '--' }}
              </div>
            </el-col>
          </el-row>

          <el-row class="descriptions-row">
            <el-col :span="12" class="descriptions-item">
              <div class="descriptions-label">
                {{ $l('form_label_goodsSpec') || '产品尺寸' }}
              </div>
              <div class="descriptions-content">
                {{ goodsSpec || '--' }}
              </div>
            </el-col>
            <el-col :span="12" class="descriptions-item">
              <div class="descriptions-label">
                {{ $l('form_label_goodsColor') || '产品颜色' }}
              </div>
              <div class="descriptions-content">
                {{ info.goodsColor || '--' }}
              </div>
            </el-col>
          </el-row>

          <el-row class="descriptions-row">
            <el-col :span="12" class="descriptions-item">
              <div class="descriptions-label">
                {{ $l('form_label_factoryOrderNo') || '工厂订单编号' }}
              </div>
              <div class="descriptions-content">
                {{ info.factoryOrderNo || '--' }}
              </div>
            </el-col>
            <el-col :span="12" class="descriptions-item">
              <div class="descriptions-label">
                {{ $l('form_label_custOrderNo') || '客户订单编号' }}
              </div>
              <div class="descriptions-content">
                {{ info.custOrderNo || '--' }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="pending-goods-descriptions">
      <div class="pending-goods-descriptions-info">
        <div class="descriptions">
          <el-row class="descriptions-row">
            <el-col :span="6" class="descriptions-item">
              <div class="descriptions-label">
                {{ $l('form_label_pendingGoodsInspectionNo') || '巡检单号' }}
              </div>
              <div class="descriptions-content">
                {{ info.pendingGoodsInspectionNo || 'NEW' }}
              </div>
            </el-col>
            <el-col :span="6" class="descriptions-item">
              <div class="descriptions-label">
                {{ $l('form_label_status') || '巡检状态' }}
              </div>
              <div class="descriptions-content" style="padding: 8px;">
                <InspectionStatus
                  :value="info.status"
                  :label="
                    info.statusText || $l('form_label_status_N') || '新增'
                  "
                />
              </div>
            </el-col>
            <el-col :span="6" class="descriptions-item">
              <div class="descriptions-label">
                {{ $l('form_label_checkStatus') || '检查结果' }}
              </div>
              <div class="descriptions-content" style="padding: 8px;">
                <InspectionCheckStatus
                  :value="info.checkStatus"
                  :label="info.checkStatusText"
                />
              </div>
            </el-col>
            <el-col :span="6" class="descriptions-item">
              <div class="descriptions-label">
                {{ $l('form_label_recheckTime') || '复查时间' }}
              </div>
              <div class="descriptions-content">
                {{ info.recheckTime || '--' }}
              </div>
            </el-col>
          </el-row>
          <el-row class="descriptions-row">
            <el-col :span="12" class="descriptions-item">
              <div class="descriptions-label">
                {{ $l('form_label_createTime') || '创建时间' }}
              </div>
              <div class="descriptions-content">
                {{ displayCreate || '--' }}
              </div>
            </el-col>
            <el-col :span="12" class="descriptions-item">
              <div class="descriptions-label">
                {{ $l('form_label_modifyTime') || '修改时间' }}
              </div>
              <div class="descriptions-content">
                {{ displayModify || '--' }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InspectionStatus from '../inspection-status'
import InspectionCheckStatus from '../inspection-check-status'
export default {
  components: { InspectionStatus, InspectionCheckStatus },
  props: { info: { type: Object, default: () => ({}) } },
  computed: {
    displayImage() {
      return this.info.defaultImageUrl || '/image/static/img/nopic.jpg'
    },
    displayCreate() {
      const { createByName, createTime } = this.info
      return [createByName, createTime].filter(Boolean).join(' at ')
    },
    displayModify() {
      const { modifyByName, modifyTime } = this.info
      return [modifyByName, modifyTime].filter(Boolean).join(' at ')
    },
    goodsSpec() {
      const { spec, specUnit } = this.info
      return [spec, specUnit].filter(Boolean).join(' / ')
    },
  },
}
</script>

<style lang="scss" scoped>
.pending-goods-descriptions {
  display: flex;
  align-items: stretch;
  flex-direction: row;
  .pending-goods-descriptions-image {
    padding: 10px;
    border: 1px solid #ebeef5;
    border-right: none;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-image {
      width: 140px;
      height: 140px;
    }
  }

  .pending-goods-descriptions-info {
    flex-grow: 1;
  }
}

.descriptions {
  --padding: 10px 12px;

  --border-width: 1px;
  --border-style: solid;
  --border-color: #ebeef5;

  --label-width: 125px;
  --label-bg: #f5f7fa;

  border-width: var(--border-width);
  border-color: var(--border-color);
  border-left-style: var(--border-style);
  border-bottom-style: var(--border-style);

  .descriptions-row {
    display: flex;
    align-items: stretch;
    .descriptions-item {
      display: flex;
      align-items: stretch;
      flex-direction: row;
      .descriptions-label {
        font-size: 14px;
        color: #909399;
        width: var(--label-width);
        min-width: var(--label-width);
        padding: var(--padding);
        border-width: var(--border-width);
        border-color: var(--border-color);
        border-top-style: var(--border-style);
        border-right-style: var(--border-style);
        background-color: var(--label-bg);
        word-break: break-all;
      }

      .descriptions-content {
        flex-grow: 1;
        font-size: 14px;
        color: #606266;
        padding: var(--padding);
        border-width: var(--border-width);
        border-color: var(--border-color);
        border-top-style: var(--border-style);
        border-right-style: var(--border-style);
        word-break: break-all;
      }
    }
  }
}

.pending-goods-descriptions:last-child {
  .descriptions {
    .descriptions-row:first-child {
      .descriptions-label,
      .descriptions-content {
        border-top: none;
      }
    }
  }
}
</style>
